import { useEffect, useRef } from "react";
import { useApi } from "../api/api";

const REFRESH_TOKEN_ENDPOINT = "/refresh-token.php";
const KEEP_ALIVE_INTERVAL_MS = 20 * 60 * 1000;
const ACTIVITY_EVENTS = ["click", "keydown", "mousemove", "scroll", "touchstart"];

export function useSessionKeepAlive() {
  const { apiFetch } = useApi();
  const lastKeepAliveRef = useRef(0);
  const inFlightRef = useRef(false);

  useEffect(() => {
    const refreshToken = async () => {
      const token = localStorage.getItem("token");
      if (!token) return;
      if (inFlightRef.current) return;

      inFlightRef.current = true;
      try {
        const data = await apiFetch(REFRESH_TOKEN_ENDPOINT, "POST");
        const refreshedToken = data?.token || data?.Token;
        if (refreshedToken) {
          localStorage.setItem("token", refreshedToken);
        }
      } finally {
        inFlightRef.current = false;
      }
    };

    const handleActivity = () => {
      const now = Date.now();
      if (now - lastKeepAliveRef.current < KEEP_ALIVE_INTERVAL_MS) return;

      lastKeepAliveRef.current = now;
      refreshToken();
    };

    ACTIVITY_EVENTS.forEach((eventName) => {
      window.addEventListener(eventName, handleActivity, { passive: true });
    });

    return () => {
      ACTIVITY_EVENTS.forEach((eventName) => {
        window.removeEventListener(eventName, handleActivity);
      });
    };
  }, [apiFetch]);
}
